export const TOKEN_KEY = 'auth_token'
export const REFRESH_KEY = 'auth_refresh_token'
export const BIOMETRIC_ENABLED_KEY = 'biometric_enabled'
